import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../navigation/header";
import Footer from "../navigation/footer";
import SideNav from "../navigation/sideNav";
import { useAuth } from "../auth/authContext";

const ProtectedRoute = ({ navData }) => {
  const { token, openSideNav } = useAuth();
  // const token = localStorage.getItem("token");
  const location = useLocation();

  // Check if the current route is allowed
  const isAllowedPath = navData.some(
    (navItem) => navItem.link === location.pathname
  );

  useEffect(() => {}, [openSideNav]);

  return token && isAllowedPath ? (
    <>
      <Header />
      <div className="d-flex" style={{ minHeight: "95vh" }}>
        <SideNav />
        <div
          style={{ padding: "2rem" }}
          className={
            openSideNav === true
              ? " bg_color mainCont"
              : " bg_color mainContClosed"
          }
        >
          <Outlet />
          <Footer />
        </div>
      </div>
    </>
  ) : (
    <Navigate to="/" replace />
  );
};

export default ProtectedRoute;
